// extracted by mini-css-extract-plugin
module.exports = {"tags":"tags__1AQVc_PRlyS1","suiList":"suiList__1P1qGAaHqbZb"};